import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-8" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_14 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_15 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_21 = { class: "col-md-12 mb-md-25" }
const _hoisted_22 = {
  class: "accordion",
  id: "basicAccordion"
}
const _hoisted_23 = { class: "accordion-item mb-0" }
const _hoisted_24 = {
  id: "basicCollapseOne",
  class: "accordion-collapse collapse show",
  "data-bs-parent": "#basicAccordion"
}
const _hoisted_25 = { class: "accordion-body row" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_34 = { class: "col-md-12" }
const _hoisted_35 = { class: "d-flex align-items-center" }
const _hoisted_36 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!
  const _component_AddAbonneModal = _resolveComponent("AddAbonneModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Form, {
          ref: "mpostBoxForm",
          onSubmit: _ctx.payer,
          "validation-schema": _ctx.mpostBoxSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                    _createTextVNode(" Commune "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createVNode(_component_Field, {
                    name: "commune",
                    modelValue: _ctx.communeSelect,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.communeSelect) = $event))
                  }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_Multiselect, _mergeProps({
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, field, {
                        options: _ctx.communesOptions,
                        searchable: true,
                        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.communeChange($event))),
                        placeholder: "Selectionner une commune",
                        noOptionsText: "Aucun enregistrement trouvé"
                      }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "commune",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                    _createTextVNode(" Bureau "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createVNode(_component_Field, {
                    modelValue: _ctx.bureauselect,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bureauselect) = $event)),
                    name: "bureau"
                  }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_Multiselect, _mergeProps({
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, field, {
                        options: _ctx.bureauxOptions,
                        onChange: _ctx.genererAdresse,
                        placeholder: "selectionner un bureau",
                        noOptionsText: "selectionner d'abord une commune"
                      }), null, 16, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "bureau",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, [
                    _cache[17] || (_cache[17] = _createTextVNode(" Abonné ", -1)),
                    _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-danger" }, "*", -1)),
                    (!_ctx.selectedAbonne)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          style: {"float":"right"},
                          class: "default-btn transition border-0 fw-medium text-white rounded-1 bg-success d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#AddAbonneModal",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleAbonne && _ctx.toggleAbonne(...args)))
                        }, [...(_cache[15] || (_cache[15] = [
                          _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1),
                          _createTextVNode(" Ajouter un abonné ", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.selectedAbonne)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          style: {"float":"right"},
                          class: "default-btn transition border-0 fw-medium text-white rounded-1 bg-success d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleAbonne && _ctx.toggleAbonne(...args)))
                        }, [...(_cache[16] || (_cache[16] = [
                          _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1),
                          _createTextVNode(" Rechercher un abonné ", -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ]),
                  (!_ctx.selectedAbonne)
                    ? (_openBlock(), _createBlock(_component_Field, {
                        key: 0,
                        name: "abonne"
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, {
                            placeholder: "Rechercher un abonné",
                            "filter-results": false,
                            "min-chars": 3,
                            "resolve-on-load": false,
                            delay: 0,
                            searchable: true,
                            "options-limit": 300,
                            options: async (query) => {
                    return await _ctx.fetchAbonnes(query)
                  },
                            onSelect: ($event: any) => (_ctx.getLoyerAndBoitCate(field.value)),
                            "no-options-text": _ctx.noOptionsTextAbb
                          }), null, 16, ["modelValue", "onUpdate:modelValue", "options", "onSelect", "no-options-text"])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_Field, {
                        key: 1,
                        name: "abonne",
                        modelValue: _ctx.selectedAbonneId,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedAbonneId) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, {
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                            options: _ctx.abonnesOps,
                            onSelect: ($event: any) => (_ctx.getLoyerAndBoitCate(field.value)),
                            placeholder: "Sélectionner un abonné"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onSelect"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])),
                  _createVNode(_component_ErrorMessage, {
                    name: "abonne",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, [
                    _cache[20] || (_cache[20] = _createTextVNode(" Téléphone ", -1)),
                    _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-danger" }, "*", -1)),
                    (_ctx.showOtp)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          style: {"float":"right"},
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sendOtp(false))),
                          class: "align-items-center"
                        }, [...(_cache[19] || (_cache[19] = [
                          _createElementVNode("i", { class: "flaticon-send lh-1 me-8 position-relative top-1" }, null, -1),
                          _createTextVNode("Vérifier le téléphone ", -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_Field, {
                    name: "numero",
                    modelValue: _ctx.telP,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.telP) = $event))
                  }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_vue_tel_input, _mergeProps({
                        placeholder: "Entrer le numéro de téléphone",
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, field, {
                        defaultCountry: "BJ",
                        mode: "international",
                        onValidate: _ctx.validate,
                        class: "shadow-none fs-md-15 text-black py-1"
                      }), null, 16, ["modelValue", "onUpdate:modelValue", "onValidate"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "numero",
                    class: "text-danger"
                  }),
                  (!_ctx.validPhone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Veuillez entrer un numéro correcte"))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.showOtp)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Code OTP ", -1)),
                      _createVNode(_component_Field, {
                        name: "otp",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Renseigner le code OTP"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "otp",
                        class: "text-danger"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                    _createTextVNode(" Adresse virtuelle "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createVNode(_component_Field, {
                    readonly: "true",
                    modelValue: _ctx.adressePostales,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.adressePostales) = $event)),
                    name: "adresseVirtuelle",
                    type: "text",
                    "aria-disabled": "true",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "Adresse virtuelle"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "adresseVirtuelle",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Frais d'abonnement ", -1)),
                  _createVNode(_component_Field, {
                    name: "loyer",
                    modelValue: _ctx.montant,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.montant) = $event)),
                    type: "text",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "Entrer les frais d'abonnements"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "loyer",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _cache[29] || (_cache[29] = _createElementVNode("button", {
                      class: "accordion-button shadow-none fw-medium",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": "#basicCollapseOne",
                      "aria-expanded": "true",
                      "aria-controls": "basicCollapseOne"
                    }, " Adresse complète à utiliser en cas livraison de colis à domicile ", -1)),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _cache[25] || (_cache[25] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Arrondissement ", -1)),
                            _createVNode(_component_Field, { name: "arrondissement" }, {
                              default: _withCtx(({ field }) => [
                                _createVNode(_component_Multiselect, _mergeProps({
                                  options: _ctx.arrondissementOptions,
                                  searchable: true,
                                  "track-by": "label",
                                  label: "label",
                                  modelValue: _ctx.selectedArrondissement,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedArrondissement) = $event))
                                }, field, {
                                  noOptionsText: "Sélectionner d'abord une commune",
                                  onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.arrondissementChange($event))),
                                  placeholder: "Sélectionner l' arrondissement"
                                }), null, 16, ["options", "modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode(_component_ErrorMessage, {
                            name: "arrondissement",
                            class: "text-danger"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _cache[26] || (_cache[26] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Quartier ", -1)),
                            _createVNode(_component_Field, { name: "quartier" }, {
                              default: _withCtx(({ field }) => [
                                _createVNode(_component_Multiselect, _mergeProps({
                                  options: _ctx.quartierOptions,
                                  searchable: true,
                                  "track-by": "label",
                                  label: "label",
                                  modelValue: _ctx.selectedQuartier,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedQuartier) = $event))
                                }, field, {
                                  noOptionsText: "Sélectionner d'abord un arrondissement",
                                  placeholder: "Sélectionner le quartier"
                                }), null, 16, ["options", "modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode(_component_ErrorMessage, {
                            name: "quartier",
                            class: "text-danger"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _cache[27] || (_cache[27] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " N° Carré / Maison ", -1)),
                            _createVNode(_component_Field, {
                              name: "adresseMaisonCarre",
                              type: "text",
                              "aria-disabled": "true",
                              class: "form-control shadow-none fs-md-15 text-black",
                              placeholder: "C/015 Maison Tchatchabloukou"
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _cache[28] || (_cache[28] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Directive ", -1)),
                            _createVNode(_component_Field, {
                              name: "adresseDirective",
                              type: "text",
                              "aria-disabled": "true",
                              class: "form-control shadow-none fs-md-15 text-black",
                              placeholder: "Non loin de la pharmacie AKONSOMBO"
                            })
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("button", {
                    class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                    type: "submit",
                    disabled: !_ctx.validPhone
                  }, " Faire un abonnement ", 8, _hoisted_36),
                  _createVNode(_component_router_link, {
                    to: "/liste-mpostboxs",
                    class: "btn btn-danger transition border-0 lh-1 fw-medium"
                  }, {
                    default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                      _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1),
                      _createElementVNode("span", { class: "position-relative" }, null, -1),
                      _createTextVNode("Annuler", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ]),
    _createVNode(_component_AddAbonneModal, { onGetabonne: _ctx.getAbonne }, null, 8, ["onGetabonne"])
  ], 64))
}